import { AppShell } from "@mantine/core";
import {
  createFileRoute,
  Outlet,
  redirect,
  useMatch,
  useNavigate,
} from "@tanstack/react-router";
import * as React from "react";
import { useRef } from "react";
import ServerName from "../../components/ServerName/ServerName";
import SkillsterSpotlight from "../../components/SkillsterSpotlight/SkillsterSpotlight";
import Drawers from "../../features/Drawers/Drawers";
import Footer from "../../features/Layout/Footer/Footer";
import MobileMenu from "../../features/Layout/Header/components/MobileMenu/MobileMenu";
import Header from "../../features/Layout/Header/Header";
import { user_has_seen_welcome_screen } from "../../helpers/keyValueKeys";
import useHasSeen from "../../hooks/useHasSeen";
import useSkillsterStore from "../../store/app";
import AdminOnly from "../../features/Layout/AdminOnly/AdminOnly";
import useIsMobile from "../../hooks/useIsMobile";

export const Route = createFileRoute("/(app)")({
  component: AppComponent,
  beforeLoad: ({ context, location }) => {
    // No pending state to wait out: the session is hydrated from storage when
    // the store module loads, before this ever runs.
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }
  },
});

function AppComponent() {
  const mobileMenuOpened = useSkillsterStore((state) => state.mobileMenuOpen);
  const navigate = useNavigate();
  const { hasNotSeenForSure } = useHasSeen({
    key: user_has_seen_welcome_screen,
  });
  const mobile = useIsMobile();

  const hasChecked = useRef(false);

  const isTicketPage = !!useMatch({
    from: "/(app)/admin/tickets/$id/",
    shouldThrow: false,
  });

  const isAdminPage = !!useMatch({
    from: "/(app)/admin",
    shouldThrow: false,
  });

  React.useEffect(() => {
    if (hasNotSeenForSure) {
      hasChecked.current = true;
      navigate({ to: "/welcome" });
    }
  }, [hasNotSeenForSure]);

  return (
    <>
      <Drawers />
      <AdminOnly>
        <SkillsterSpotlight />
      </AdminOnly>
      <AppShell
        header={{
          height: {
            base: 62,
            md: 76,
          },
        }}
        transitionDuration={0}
        navbar={{
          width: 300,
          breakpoint: "md",
          collapsed: { mobile: !mobileMenuOpened, desktop: true },
        }}
      >
        <AppShell.Header withBorder={false}>
          <Header />
        </AppShell.Header>
        <AppShell.Navbar bg="bluegray.7">
          {mobile && <MobileMenu />}
        </AppShell.Navbar>
        <AppShell.Main>
          <React.Suspense>
            <Outlet />
          </React.Suspense>
        </AppShell.Main>
        {!isTicketPage && !isAdminPage && <Footer />}
      </AppShell>
      <AdminOnly>
        <ServerName />
      </AdminOnly>
    </>
  );
}
